import { ZealApiSuccessResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import type {
  TGetAiConversationsRequestSchema,
  TGetAiConversationsResponseSchema,
} from "./getAiConversations.schema";

type TSuccess = ZealApiSuccessResponse<TGetAiConversationsResponseSchema>;

export const getAiConversations = (axios: IAxiosInstance) => {
  return async (
    params: TGetAiConversationsRequestSchema
  ): Promise<TGetAiConversationsResponseSchema> => {
    try {
      const response = await axios.noRetry.get<TSuccess>(
        "/api/ai/conversations",
        {
          params: { companyId: params.companyId, userId: params.userId },
        }
      );
      const body = response.data;
      if (body?.success === true) {
        return body.data;
      }
      throw new ZealClientError(response);
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
